/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React from "react";
import { useGLTF } from "@react-three/drei";

const CartonBox = (props) => {
  const { nodes, materials } = useGLTF("/new_models/carton_box.glb");
  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.carton_box.geometry}
        material={materials.Material}
      />
    </group>
  );
}

useGLTF.preload("/new_models/carton_box.glb");

export default CartonBox;
